import { useState, useEffect } from "react";
import { Banner, BlueLarge, ServiceImage } from "../images/index";
import { Img1, Img2, Img3, Img4, Img5, Img6 } from "../images/Services";
import { useNavigate } from "react-router-dom";
import ScrollToTopButton from "../components/ScrollToTopButton";
import useSlug from "./SlugComp";
import SEO from "./Seo";
import { getPagesBySlug } from "../services/apiService";

const categories = [
  {
    name: "Global Capability Centers (GCCs)",
    img: Img1,
    title:
      "At TechProjects, we go beyond technology support — we design solutions that build, automate, and transform businesses.",
    keyPoints: [
      "Custom-built GCCs for retail, logistics, and government",
      "Full-service operations: IT, support, analytics, and engineering",
      "24/7 agile delivery with U.S.–India hybrid teams",
    ],
    cta: "GCC",
  },
  {
    name: "Digital Strategy & Transformation",
    img: Img2,
    title:
      "At TechProjects, we drive digital-first innovation — helping enterprises modernize, automate, and scale with confidence.",
    keyPoints: [
      "Application modernization & cloud migration",
      "UX/UI design & product engineering",
      "AI/ML integration & digital workflow automation",
      "Data insights with Tableau, Power BI & Snowflake",
    ],
    cta: "DST",
  },
  {
    name: "AI & Intelligent Automation",
    img: Img3,
    title:
      "We use AI and automation to make work easier, faster, and smarter. Our solutions help reduce manual effort, cut costs, and improve customer experiences.",
    keyPoints: [
      "AI forecasting & personalization",
      "Robotic Process Automation (RPA)",
      "Conversational AI & chatbots",
      "Computer vision & smart workflows",
    ],
    cta: "AI",
  },
  {
    name: "Platform Engineering & Product Development",
    img: Img4,
    title:
      "We design and build secure, scalable platforms and digital products that help businesses grow faster. From apps to enterprise platforms, TechProjects delivers end-to-end engineering with agility and quality.",
    keyPoints: [
      "Cloud-native platforms & microservices",
      "Enterprise apps & mobile product development",
      "UX/UI design with seamless experiences",
      "DevOps & continuous delivery for faster launches",
    ],
    cta: "PEPD",
  },
  {
    name: "CyberSecurity & Compliance",
    img: Img5,
    title:
      "We protect your business with strong security and compliance programs. From threat detection to regulatory standards, TechProjects keeps your systems safe and resilient.",
    keyPoints: [
      "24/7 security monitoring & incident response",
      "Cloud & infrastructure protection",
      "Compliance with PCI DSS, HIPAA, GDPR, NIST",
      "Employee security training & awareness",
    ],
    cta: "CC",
  },
  {
    name: "Staffing & Workforce Solutions",
    img: Img6,
    title:
      "We connect businesses with the right talent, fast. Our flexible staffing models help you scale teams, reduce hiring costs, and meet project needs with ease.",
    keyPoints: [
      "On-demand staffing & contract hiring",
      "Recruitment Process Outsourcing (RPO)",
      "Permanent & executive hiring",
      "Scalable models to support talent acquisition teams",
    ],
    cta: "SWS",
  },
];

function Services() {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const [metaData, setMetaData] = useState({});
  const slug = useSlug();

  useEffect(() => {
    console.log(slug);
    if (!slug) return;

    const fetchSEO = async () => {
      try {
        const res = await getPagesBySlug(slug.toLowerCase());
        setMetaData(res?.data || {});
      } catch (error) {
        console.error("Error fetching SEO:", error);
      }
    };

    fetchSEO();
  }, [slug]);

  const navTo = (e) => {
    if (e === "GCC") {
      navigate("/Services/GCC");
    } else if (e === "DST") {
      navigate("/Services/DST");
    } else if (e === "AI") {
      navigate("/Services/AI");
    } else if (e === "PEPD") {
      navigate("/Services/PE&PD");
    } else if (e === "CC") {
      navigate("/Services/CSC");
    } else if (e === "SWS") {
      navigate("/Services/SWS");
    }
  };
  const handleClick = () => {
    navigate("/contact");
  };
  return (
    <>
      <SEO {...metaData} />
      <div>
        <div className="relative min-h-[630px]">
          <img
            src={Banner}
            alt="About Banner"
            className="absolute inset-0 h-full w-full "
          />

          <div className="absolute flex items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto left-0 right-0 px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
            <div className="max-w-2xl font-roboto space-y-6">
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
                <span className="text-[#475569] font-bold text-xl">
                  OUR SERVICES
                </span>
              </span>
              <h1 className="md:text-7xl text-4xl text-[#29327f] font-bold">
                Technology. Talent. Transformation.
              </h1>
              <p className="text-md text-[#404040]">
                At TechProjects, we help businesses grow, stay secure, and
                succeed with the right technology and talent.
              </p>
            </div>

            <div className="max-w-xl flex justify-end">
              <img
                src={ServiceImage}
                alt="IT Hiring"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>

        <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto w-full py-10 px-4 md:px-0 bg-white font-roboto flex flex-col items-center">
          <div className="text-center mb-3 space-y-6">
            <span className="flex items-center justify-center font-bold text-lg tracking-wider space-x-2">
              <span className="w-[21px] h-[6px] bg-activeColor"></span>
              <span className="w-[36px] h-[6px] bg-activeColor"></span>
            </span>
            <h1 className="text-3xl md:text-7xl font-extrabold text-[#434253] mb-2">
              Our Services
            </h1>
            <p className="text-[#404040] text-400 text-lg">
              At TechProjects, we deliver end-to-end technology and workforce
              solutions that help businesses innovate, scale, and stay ahead.
              From building Global Capability Centers to driving digital
              transformation, AI, and talent solutions — we provide the
              expertise and flexibility to meet your unique needs.
            </p>
          </div>

          <div className="flex flex-wrap justify-start gap-4 py-6">
            {categories.map((c, idx) => (
              <button
                key={idx}
                onClick={() => setActiveIndex(idx)}
                className={`px-6 py-3 text-start rounded-md text-2xl font-500 transition-all duration-300
              ${
                activeIndex === idx
                  ? "bg-activeColor text-white"
                  : "text-gray-700 hover:bg-[#FA3746]/10 hover:text-[#FA3746]"
              }`}
              >
                {c.name}
              </button>
            ))}
          </div>

          <div className="flex flex-col md:flex-row-reverse justify-between items-center md:items-center md:gap-16 mt-12">
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-[#404040] mb-3">
                {categories[activeIndex].title}
              </h3>
              <ul className="mb-14 space-y-6 font-400 text-lg mt-8 ml-6 text-[#5F6870]">
                {categories[activeIndex].keyPoints.map((b, i) => (
                  <li key={i} className="list-disc list-inside">
                    {b}
                  </li>
                ))}
              </ul>
              <div className="flex justify-end">
                <a
                  onClick={() => navTo(categories[activeIndex].cta)}
                  className="text-[#F42F39] font-500 text-xl rounded-lg border-[#D9D9D9] border px-8 py-4 inline-flex items-center cursor-pointer"
                >
                  Read More
                  <i className="fa fa-arrow-right text-xs ml-2 mt-1"></i>
                </a>
              </div>
            </div>
            <div className="flex mt-6 md:mt-0">
              <img
                src={categories[activeIndex].img}
                alt={categories[activeIndex].title}
                className="w-full object-contain"
              />
            </div>
          </div>
        </div>

        <section
          className="text-white flex items-center py-8 md:py-[4rem] relative overflow-hidden bg-cover bg-no-repeat font-roboto"
          style={{ backgroundImage: `url(${BlueLarge})` }}
        >
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto text-center px-3 md:px-6">
            <h2 className="text-3xl md:text-4xl xl:text-6xl max-w-4xl mx-auto font-extrabold text-white leading-tight mb-[2rem] md:mb-[3rem]">
              Let’s Build Your Team Together
            </h2>
            <p className="text-lg font-400 text-[#CBD5E1] max-w-3xl  mx-auto">
              Have questions or want to learn more about TechProjects? We’re
              here to help. Whether you're a job seeker, client, or partner, our
              team is ready to assist you.
            </p>
            <div className="flex flex-wrap  justify-center mt-10 gap-6 md:gap-12">
              <button
                onClick={handleClick}
                type="submit"
                className="bg-activeColor text-white text-lg md:text-2xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium hover:bg-red-600 transition-all flex items-center gap-4"
              >
                Contact Us Now
              </button>
            </div>
          </div>
        </section>

        <ScrollToTopButton />
      </div>
    </>
  );
}

export default Services;
